import { inject, computed } from 'vue';
import { useStore } from 'vuex';

import { UpdateCurrentLanguageCode } from '~/constants/actions';
import { GetCurrentLanguageCode } from '~/constants/getters';

import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';

const getDocumentTranslationChannelName = (externalId) => `${externalId}:translations`;

export default () => {
  const arcaneApiGateway = inject('arcaneApiGateway');
  const realtime = inject('realtime');
  const store = useStore();

  const getAvailableTranslations = async (reference) => {
    const { externalId } = reference;
    const { data } = await arcaneApiGateway.post(apiGatewayEndpoints.translation.getAvailableTranslations, {
      externalId,
    });
    return data;
  };

  const getTargetLanguages = async (externalId, sourceLanguage) => {
    const { data } = await arcaneApiGateway.post(apiGatewayEndpoints.translation.getTargetLanguages, {
      externalId,
      sourceLanguage,
    });
    return data.languages;
  };
  const getSourceLanguages = async (externalId) => {
    const { data } = await arcaneApiGateway.post(apiGatewayEndpoints.translation.getSourceLanguages, { externalId });
    return data.sourceLanguages;
  };

  const setCurrentPdfLanguage = (languageCode) => {
    store.dispatch(`translationStore/${UpdateCurrentLanguageCode}`, languageCode);
  };

  const currentLanguageCode = computed(() => store.getters[`translationStore/${GetCurrentLanguageCode}`]);

  const subscribeToDocumentTranslationChannel = (externalId, topic, callback) => {
    console.log(getDocumentTranslationChannelName(externalId));
    realtime.subscribeToOrganizationChannel({
      channel: getDocumentTranslationChannelName(externalId),
      topic,
      cb: callback,
    });
  };

  const unsubscribeFromDocumentTranslationChannel = (externalId, topic, callback) => {
    realtime.unsubscribeFromOrganizationChannel({
      channel: getDocumentTranslationChannelName(externalId),
      topic,
      cb: callback,
    });
  };

  return {
    getAvailableTranslations,
    getTargetLanguages,
    getSourceLanguages,
    setCurrentPdfLanguage,
    currentLanguageCode,
    subscribeToDocumentTranslationChannel,
    unsubscribeFromDocumentTranslationChannel,
  };
};
